<template>
  <main-layout>
	<data-container>
		<template slot="controls">
			<custom-search
				:placeholder="$t('search')"
				:disable="listLoading"
				v-model="keyword"
                @input="changeFilter()"
			>
			</custom-search>

			<div class="control-wrapper">
				<!-- <custom-option
					class="option"
					:options="filterOptions"
					placeholder="Filter by"
					:disable="listLoading"
					v-model="params.filterBy"
				>
				</custom-option> -->

				<custom-option
					class="option"
					:options="sortOptions"
					:placeholder="$t('sort')"
					:disable="listLoading"
					v-model="params.sortBy"
                    @input="changeFilter()"
				>
				</custom-option>
			</div>
		</template>

		<template
			slot="content"
			class="table-wrapper"
		>
			<custom-table
				:fields="fields"
				:items="routerList.data"
				:current-page="params.page"
				:items-per-page="params.count"
				:total-count="routerList.total"
				:is-loading="listLoading"
                :is-selectable="false"
				@changePage="changePage($event)"
			>
				<template #loading>
					<loading />
				</template>

				<template
					#band_count="{item}"
				>
					<span>
						{{ item.band_count || 0 }}
					</span>
				</template>

                <template
					#session_count="{item}"
				>
					<span>
						{{ item.session_count || 0 }}
					</span>
				</template>

				<template
					#actions="{item}"
				>
					<button class="button--ok" @click="manage(item)">{{ $t('manage') }}</button>

				</template>
			</custom-table>
		</template>
	</data-container>

	<modal v-if="login" @close="closeModal()">
		<form @submit.prevent="gotoBands()">
			<p class="msg--error" v-if="loginError">{{ loginError }}</p>
            <div class="password">
                <custom-input :label="$t('password')" :type="showPassword ? 'text' : 'password'" v-model="password"></custom-input>
                <span class="toggle" @click="showPassword = !showPassword">{{ showPassword ? $t('hide') : $t('show') }}</span>
            </div>

			<div class="flex-row">
				<button class="button--cancel" @click="login = false">{{ $t('cancel') }}</button>
				<button class="button--ok" type="submit">{{ $t('ok') }}</button>
			</div>
		</form>
	</modal>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout.vue'
import DataContainer from '@/components/layouts/DataContainer.vue'
import CustomTable from '@/components/utils/CustomTable.vue'
import CustomSearch from '@/components/utils/CustomSearch.vue'
import CustomOption from '@/components/utils/CustomOption.vue'
import CustomInput from '@/components/utils/CustomInput.vue'
import Modal from '@/components/layouts/Modal.vue'

import * as router from '@/store/router/app.js'

import { mapFields } from 'vuex-map-fields'
export default {
	data () {
		return {
			password: '',
			showPassword: false,

			// filterOptions: [
			// 	{
			// 		text: 'Online',
			// 		value: 'online'
			// 	},

			// 	{
			// 		text: 'Offline',
			// 		value: 'offline'
			// 	},

			// 	{
			// 		text: 'For Activation',
			// 		value: 'for_activation'
			// 	}
			// ],

			login: false,
			band: null
		}
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['router/']) {
			this.$store.registerModule('router', router.default)
		}
	},

	async created () {
		await this.setParams()
	},

	computed: {
		...mapFields('router', [
			'params',
			'keyword',
			'routerList',
			'listLoading',
			'loginError'
		]),

		sortOptions () {
			return [
				{
					text: this.$t('latest'),
					value: 'desc'
				},

				{
					text: this.$t('oldest'),
					value: 'asc'
				}
			]
		},

		fields () {
			return [
				{ name: 'id', text: this.$t('id') },
				{ name: 'name', text: this.$t('upmood_mass_name') },
				{ name: 'mac_address', text: this.$t('mac_address'), style: 'width: 10.5rem' },
				{ name: 'ip', text: this.$t('ip') },
				{ name: 'band_count', text: this.$t('no_of_band') },
				{ name: 'session_count', text: this.$t('no_of_sessions') }
			]
		}
	},

	watch: {
		// keyword: {
		// 	handler () {
		// 		this.changeFilter()
		// 	},
		// 	deep: true
		// },

		// params: {
		// 	handler () {
		// 		this.changeFilter()
		// 	},
		// 	deep: true
		// }
	},

	methods: {
		/* Created Methods */
		setParams () {
			const { keyword, filter, sort_type, page, count } = this.$route.query

			if (keyword) this.keyword = keyword
			if (filter) this.params.filterBy = filter
			if (sort_type) this.params.sortBy = sort_type
			if (page > 1) this.params.page = parseInt(page)
			if (count > 10) this.params.count = parseInt(count)

			this.changeFilter()
		},

		async changeFilter (resetPage = true) {
			clearTimeout(this.filterTimeout)

			this.filterTimeout = setTimeout(async () => {
				if (resetPage) this.params.page = 1

				const query = {}
				const { sortBy } = this.params

				if (this.keyword) query.keyword = this.keyword
				if (sortBy) query.sort_type = sortBy
				if (this.params.page > 1) query.page = this.params.page
				if (this.params.count > 10) query.count = this.params.count

				await this.$router.push({ query: query })

				this.getRouteList()
			}, 0)
		},

		getRouteList () {
			const path = this.$route.fullPath.replace(this.$route.path, '/insight/cassia/router-list')

			this.$store.dispatch('router/getRouterList', path)
		},

		/* Template Methods */
		manage (item) {
			this.band = item
			this.login = true
		},

		async gotoBands () {
			let form = new FormData()
			form.append('password', this.password)
			await this.$store.dispatch('router/checkPassword', form)

			if (!this.loginError) {
				this.login = false
				this.$router.push({ path: `/bands/${this.band.id}` })
			}
		},

		closeModal () {
			this.band = null
			this.login = false
		},

		changePage (e) {
			if (e.itemsPerPage !== this.params.count) {
				this.params.count = e.itemsPerPage
				this.changeFilter(true)
				return
			}

			if (e.currentPage !== this.params.page) {
				this.params.page = e.currentPage
				this.changeFilter(false)
			}
		}
	},

	components: {
		MainLayout,
		DataContainer,
		CustomTable,
		CustomSearch,
		CustomOption,
		CustomInput,
		Modal
	}
}
</script>

<style lang="scss" scoped>
.control-wrapper {
	display: flex;
	justify-content: flex-start;
	width: 100%;
	padding: 1rem 0;

	> * {
		margin-right: .5rem;
	}
}

.flex-row {
	justify-content: flex-end;
}

.online {
	color: #2DC4B6;
}

.custom-table::v-deep {
	.id {
		width: 6rem;
	}
	.bands {
		width: 4rem;
	}

	.status {
		width: 5rem;
	}

	.mac_address, .ip_address {
		width: 8.5rem;
	}
}

.password {
    position: relative;
    width: 100%;

    .toggle {
        font-size: 14px;
        cursor: pointer;
        position: absolute;
        right: 9px;
        top: 42px;
        text-transform: uppercase;
        color: #3A9BEF;
    }
}
</style>
